/**
 * Compares two arrays and returns true if they are identical false if they differ
 * @param {string} array1 
 * @param {string} array12
 * @returns boolean
 */
export function arraysAreSame(array1, array2) {
    if(Array.isArray(array1)
    && Array.isArray(array2)) {
        if(array1.length === array2.length) {
            return JSON.stringify(array1) === JSON.stringify(array1);
        }
    } else {
        console.error('arraysAreSame not equal types ', array1, array2);
    }
    return false;
}